"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledExpander = exports.TitleWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MobileNav = require("./MobileNav.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var TitleWrapper = _styledComponents.default.span.withConfig({
  displayName: "LanguageDropDownstyle__TitleWrapper",
  componentId: "p0bv8b-0"
})(["display:flex;"]);
exports.TitleWrapper = TitleWrapper;
var StyledExpander = (0, _styledComponents.default)(_MobileNav.StyledExpander).withConfig({
  displayName: "LanguageDropDownstyle__StyledExpander",
  componentId: "p0bv8b-1"
})(["border-top:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui03;
});
exports.StyledExpander = StyledExpander;